module.exports = __webpack_public_path__ + "img/img-2.12f070d7.webp";